export default __webpack_public_path__ + "static/media/earlySubscriberAndroid_2.2b06396d.png";